import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import memo from "set-state-compare/build/memo"
import React from "react"
import Route from "@kaspernj/api-maker/build/router/route"
import Switch from "@kaspernj/api-maker/build/router/switch"
import {useWoofRouter} from "shared/woof-router"
/** @typedef {object} RoutesAdminEmailTemplatesRouteProps */

/** @typedef {object} RoutesAdminEmailTemplatesRouteState */

/**
 * @extends {ShapeComponent<RoutesAdminEmailTemplatesRouteProps, RoutesAdminEmailTemplatesRouteState>}
 */
class RoutesAdminEmailTemplatesRoute extends ShapeComponent {
  setup() {
    this.woofRouter = useWoofRouter()
  }

  render() {
    return (
      <Switch name="email-templates">
        <Route component="edit" exact path="new" />
        <Route component="edit" exact path=":email_template_id/edit" />
        <Route component="show" exact path=":email_template_id" />
        <Route component="index" exact />
        <Route componentPath="fallback" fallback onMatch={this.tt.onFallbackMatch} />
      </Switch>
    )
  }

  onFallbackMatch = () => this.woofRouter.setPageNotFound(true)
}

export default memo(shapeComponent(RoutesAdminEmailTemplatesRoute))
